import { createRoutine } from 'redux-saga-routines';

export const fetchStatBarConfig = createRoutine('FETCH_STAT_BAR_CONFIG');

export const saveStatBarConfig = createRoutine('SAVE_STAT_BAR_CONFIG');
